import { render, staticRenderFns } from "./SettingsClinicalTeam.vue?vue&type=template&id=095b62b6"
import script from "./SettingsClinicalTeam.vue?vue&type=script&lang=js"
export * from "./SettingsClinicalTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports